import PropTypes from "prop-types";
// @mui
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
//
import Logo from "../logo";

// ----------------------------------------------------------------------

// Branding 2026: el indicador de carga es circular en todo el sistema.
// Antes eran dos cuadrados girando que morfeaban a círculo (borderRadius
// animado); el ticket pide unificar con el círculo que ya usan las tablas.
export default function SplashScreen({ sx, ...other }) {
  return (
    <Box
      sx={{
        right: 0,
        width: 1,
        bottom: 0,
        height: 1,
        zIndex: 9998,
        display: "flex",
        position: "fixed",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        ...sx,
      }}
      {...other}
    >
      <Box
        sx={{
          display: "inline-flex",
          position: "relative",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress
          size={104}
          thickness={2}
          color="primary"
        />

        <Logo
          variant="mark"
          disabledLink
          sx={{ width: 52, position: "absolute" }}
        />
      </Box>
    </Box>
  );
}

SplashScreen.propTypes = {
  sx: PropTypes.object,
};
